import React from 'react';

function HomePopupArrowIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="72"
      viewBox="0 0 65 72"
      fill="none"
    >
      <g filter="url(#filter0_d_204_6724)">
        <path
          d="M34.1921 13.7103L26.1158 21.6708C24.442 23.3206 24.5445 26.0511 26.3373 27.5708L34.4135 34.4168C37.0125 36.6199 41 34.7727 41 31.3656V16.5591C41 13.0094 36.7202 11.2185 34.1921 13.7103Z"
          fill="#FF8A00"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_204_6724"
          x="0.923828"
          y="0.551025"
          width="64.0762"
          height="70.8223"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="12" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_204_6724"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_204_6724"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default HomePopupArrowIcon;
